import { useAppContext } from '@/contexts/AppContext';
import { formatPhoneNumber } from '@/utils/phone';
import { Link } from '@tanstack/react-router';
import type { FC } from 'react';

const HomeCTASection: FC = ({}) => {
  const { community } = useAppContext();

  return (
    <section className="py-16 md:py-24 bg-primary-600 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Find Your New Home?</h2>
        <p className="text-xl mb-8">
          Schedule a tour today and experience the BTR Community lifestyle
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/floor-plans"
            className="inline-block px-8 py-4 bg-accent-600 text-white rounded-none font-semibold uppercase tracking-wider hover:bg-accent-700 transition-colors duration-200"
          >
            View Floor Plans
          </Link>
          {community.contactInformation?.phone ? (
            <a
              href={`tel:${community.contactInformation.phone}`}
              className="inline-block px-8 py-4 border border-white text-white rounded-none font-semibold uppercase tracking-wider hover:bg-white hover:text-primary-600 transition-colors duration-200"
            >
              Call or Text: {formatPhoneNumber(community.contactInformation.phone)}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default HomeCTASection;
